import { Dialog, DialogTitle, Tab } from '@mui/material';
import Box from '@mui/material/Box';
import { Check } from '@mui/icons-material';
import { Button } from '../../../../shared/components/button/Button';
import { TabContext, TabList } from '@mui/lab';
import { InsertDriveFile, LocalShipping } from '@mui/icons-material';
import { TabCadastro } from './components/TabCadastro';
import { TabTransporteParcelas } from './components/TabTransporteParcelas';

interface NFViewDialogProps {
  handleCloseModal: () => void;
  modalIsOpen: boolean;
  activeTab: string;
  nfPreView: any;
  handleFinishNf: () => void;
  handleTabChange: any;
}

const TABS = [
  {
    id: '1',
    label: 'Cadastro',
    icon: <InsertDriveFile />,
  },
  {
    id: '2',
    label: 'Transporte/Parcelas',
    icon: <LocalShipping />,
  }
]

export const NFViewDialog = ({
  handleCloseModal,
  modalIsOpen,
  nfPreView,
  handleFinishNf,
  activeTab,
  handleTabChange,
}: NFViewDialogProps) => {

  return (
    <Dialog
      onClose={() => handleCloseModal()}
      open={modalIsOpen}
      fullWidth={true}
      maxWidth={'lg'}
    >
      <Box className={'flex justify-between pt-4 pr-4'}>
        <DialogTitle className='!font-bold !text-md'>
          Nota Fiscal Inclusão
        </DialogTitle>
        <Box>
          <Button
            className={''}
            variant='success'
            onClick={handleFinishNf}
            iconStart={<Check />}
            title={'Finalizar'}
            disabled={nfPreView?.nfe_Status?.toLowerCase() !== 'aberto'}
          />
        </Box>
      </Box>
      <Box className={'h-screen'}>
        <TabContext value={activeTab}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList
              onChange={handleTabChange}
              aria-label='lab API tabs example'
            >
              {TABS.map((item) => (
                <Tab
                  key={item.id}
                  icon={item.icon}
                  label={item.label}
                  value={item.id}
                />
              ))}
            </TabList>
          </Box>
          <TabCadastro nfPreView={nfPreView} />
          <TabTransporteParcelas nfPreView={nfPreView} />
        </TabContext>
      </Box>
    </Dialog>
  );
};